import React from 'react';
import { UncontrolledCollapse, Button, CardBody, Card } from 'reactstrap';

const SportsExtra = () => (
  <div>
    <h2>Sports Extra</h2>
    <p>13 Channels of Premium Sports Content in HD. $5</p>
    <Button outline color="success" id="sportsextrapacktoggle" style={{ marginBottom: '1rem' }}>
      Show/Hide Channel Listing
    </Button>
    <UncontrolledCollapse toggler="#sportsextrapacktoggle">
      <Card>
        <CardBody>
          316 - Big Ten Network<br />
          317 - Big Ten Network Alternate<br />
          319 - PAC12<br />
          322 - ESPN Goal Line<br />
          323 - Fox College Sports Atlantic<br />
          324 - Fox College Sports Central<br />
          325 - Fox College Sports Pacific<br />
          330 - Outdoor Channel<br />
          331 - Sportsman Channel<br />
          332 - World Fishing Network<br />
          333 - Pursuit<br />
          339 - TVG2<br />
          341 - MAV TV<br />
        </CardBody>
      </Card>
    </UncontrolledCollapse>
  </div>
);

export default SportsExtra;


// WEBPACK FOOTER //
// ./src/components/sections/services/tv/sportsextra.js